import { env } from "$lib/env.client";
import * as Sentry from "@sentry/sveltekit";
import type { HandleClientError } from "@sveltejs/kit";

if (env.logToSentry) {
	let tracePropagationTargets: string[];
	switch (import.meta.env.MODE) {
		case "production":
			tracePropagationTargets = ["app.smore.com", "app.smore.schoolstatus.com"];
			break;
		case "staging":
			tracePropagationTargets = ["app.staging.smore.com", "app.staging.smore.schoolstatus.com"];
			break;
		case "development":
			tracePropagationTargets = ["app.smore.dev", "connect-app.smore.dev"];
			break;
		default:
			tracePropagationTargets = [];
	}

	Sentry.init({
		dsn: env.PUBLIC_SENTRY_DSN,
		environment: import.meta.env.MODE,
		integrations: [Sentry.captureConsoleIntegration({ levels: ["error", "warning"] }), Sentry.browserTracingIntegration()],
		tracesSampleRate: 0.05,
		// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
		tracePropagationTargets
	});
	Sentry.setContext("target", { target: "client" });

	// // TODO: Need to check whether this really works
	// LogRocket.getSessionURL((sessionURL) => {
	// 	Sentry.getCurrentScope().setTag("sessionURL", sessionURL);
	// });
}

const consoleErrorHandler: HandleClientError = ({ error, event }) => {
	console.error("A client error occurred:", error, event);
};

export const handleError = env.logToSentry ? Sentry.handleErrorWithSentry() : consoleErrorHandler;
